import { render, staticRenderFns } from "./RouteDesignStopGroups.vue?vue&type=template&id=213950b8&scoped=true&"
import script from "./RouteDesignStopGroups.vue?vue&type=script&lang=js&"
export * from "./RouteDesignStopGroups.vue?vue&type=script&lang=js&"
import style0 from "./RouteDesignStopGroups.vue?vue&type=style&index=0&id=213950b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213950b8",
  null
  
)

export default component.exports